import { MultipleSelect } from "./multiple-select.service";
import { MultipleSelectController } from "./multiple-select.controller";

angular
    .module("thor.core.multiple-select", [])
    .service("multipleSelect", MultipleSelect)
    .component("multipleSelect", {
        bindings: {
            elem: "<",
            type: "<"
        },
        template: require("./multiple-select.html"),
        controller: MultipleSelectController,
        controllerAs: "msCtrl"
    });
